import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { Box } from "../../Box/index.js";
import { Typography } from "../../Typography/index.js";
import { Icon } from "../../Icon/index.js";
const Tag = (t0)=>{
    const $ = c(10);
    const { label, disabled, onDelete } = t0;
    const t1 = disabled ? "text.light.tertirary" : "text.light.primary";
    let t2;
    if ($[0] !== label || $[1] !== t1) {
        t2 = /*#__PURE__*/ jsx(Typography, {
            variant: "body3",
            color: t1,
            children: label
        });
        $[0] = label;
        $[1] = t1;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== disabled || $[4] !== label || $[5] !== onDelete) {
        t3 = !disabled && /*#__PURE__*/ jsx(Box, {
            width: 20,
            height: 20,
            cursor: disabled ? "default" : "pointer",
            testId: `tag-delete-${label}`,
            onClick: onDelete,
            children: /*#__PURE__*/ jsx(Icon, {
                name: "cancel_outline",
                size: "20",
                color: "stroke.secondary"
            })
        });
        $[3] = disabled;
        $[4] = label;
        $[5] = onDelete;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== t2 || $[8] !== t3) {
        t4 = /*#__PURE__*/ jsxs(Box, {
            display: "flex",
            alignItems: "center",
            gap: "8",
            px: "8",
            height: 32,
            border: 1,
            bgcolor: "bg.greyscale.primary",
            borderColor: "stroke.primary",
            radius: "m",
            children: [
                t2,
                t3
            ]
        });
        $[7] = t2;
        $[8] = t3;
        $[9] = t4;
    } else t4 = $[9];
    return t4;
};
export { Tag };
